//react
import { useLocation } from 'react-router-dom';

// context hooks
import useAsp from 'hooks/useAsp';
import { useEffect } from 'react';

const AccesstradeTag = () => {
  const { isThanks } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'Accesstrade';
    const isExsistScript = document.getElementById(scriptId);
    if (!!isExsistScript) isExsistScript.remove();
    const scriptId1 = 'AccesstradeTag-load1';
    const isExsistLoadScript1 = document.getElementById(scriptId1);
    if (!!isExsistLoadScript1) isExsistLoadScript1.remove();
    if (!isThanks) {
      const script1 = document.createElement('script');
      script1.src = 'https://h.accesstrade.net/js/nct/lp.min.js';
      script1.id = scriptId1;
      script1.setAttribute('async', '');
      document.head.appendChild(script1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return <></>;
};

export default AccesstradeTag;
